import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import UserAvatar from 'components/global/UserAvatar';
import GlobalCard from '../../../global/Card';

const UserCard = incomingProps => {
  const props = {
    ...{
      countdown: '',
      disabled: null,
      user: {
        first_name: '',
        last_name: '',
        avatar: { url: undefined },
        degrees: {},
      },
      partner: null,
    },
    ...incomingProps,
  };
  const { countdown, user, disabled, partner } = props;
  const parseDegrees = degrees =>
    _.map(degrees, degree => degree.acronym).join(', ');

  const userAvatar = client => (
    <div style={{ marginBottom: 20 }}>
      <UserAvatar
        user={client}
        size={100}
        style={{ margin: '0 auto', display: 'flex' }}
      />
      <h3 className="card-title">{client.preferred_name_with_last_name}</h3>
    </div>
  );

  return (
    <GlobalCard style={{ margin: '0 auto' }}>
      {user && (
        <div>
          {userAvatar(user)}
          {partner && userAvatar(partner)}
          <p style={{ marginBottom: '60px' }} className="card-subtitle-italics">
            {parseDegrees(user.degrees)}
          </p>
          <h3 className="card-subtitle">
            <FormattedMessage defaultMessage="Time Til Session" />
          </h3>
          <h3 style={{ marginBottom: '40px' }} className="card-time">
            {countdown}
          </h3>
          <Link to={`/sessions/providers/video_call/${props.appointment_id}`}>
            <Button
              className={
                disabled ? 'flat-button-light-green' : 'flat-button-green'
              }
            >
              {<FormattedMessage defaultMessage="Start Session" />}
            </Button>
          </Link>
        </div>
      )}
    </GlobalCard>
  );
};

UserCard.propTypes = {
  countdown: PropTypes.string,
  user: PropTypes.object,
  disabled: PropTypes.bool,
  partner: PropTypes.object,
};

export default UserCard;
